import React from 'react';
import PropTypes from 'prop-types';
import { Icon } from 'components';
import styles from './SocialNetworkIcon.scss';
import gmbLogo from '../../assets/google-my-business-logo.svg';
import igLogo from '../../assets/instagram-logo.svg';
import fbLogo from '../../assets/facebook-logo.svg';
import liLogo from '../../assets/linkedin-icon.svg';
import xLogo from '../../assets/x-logo.svg';

function SocialNetworkIcon(props) {
  var iconStyle = props.iconStyle,
      network = props.network,
      networkSubType = props.networkSubType;

  var IconComponent = function () {
    switch (network) {
      case 'facebook':
        return function () {
          return /*#__PURE__*/React.createElement("img", {
            style: props.iconStyle,
            src: fbLogo
          });
        };

      case 'instagram':
        return function () {
          return /*#__PURE__*/React.createElement("img", {
            style: props.iconStyle,
            src: igLogo
          });
        };

      case 'google':
        return function () {
          return /*#__PURE__*/React.createElement("img", {
            style: props.iconStyle,
            src: gmbLogo
          });
        };

      case 'twitter':
        return function () {
          return /*#__PURE__*/React.createElement("img", {
            style: props.iconStyle,
            src: xLogo
          });
        };

      case 'linkedin':
        return function () {
          return /*#__PURE__*/React.createElement("img", {
            style: props.iconStyle,
            src: liLogo
          });
        };

      default:
        return function () {
          return null;
        };
    }
  }();

  if (networkSubType) {
    if (networkSubType === 'messenger') {
      return /*#__PURE__*/React.createElement("span", {
        className: "".concat(styles.networkIcon, " ").concat(styles[props.size]),
        style: props.style
      }, /*#__PURE__*/React.createElement(Icon, {
        name: "messenger",
        iconStyle: iconStyle
      }));
    } else if (networkSubType === 'review') {
      return /*#__PURE__*/React.createElement("span", {
        className: "".concat(styles.networkIcon, " ").concat(styles[props.size]),
        style: Object.assign({
          backgroundColor: '#5E90FF',
          borderRadius: '50%'
        }, props.style)
      }, /*#__PURE__*/React.createElement("i", {
        className: "icon ion-ios-star",
        iconStyle: props.iconStyle
      }));
    }
  } else {
    return /*#__PURE__*/React.createElement("span", {
      className: "".concat(styles.networkIcon, " ").concat(styles[props.network], " ").concat(styles[props.size]),
      style: props.style
    }, /*#__PURE__*/React.createElement(IconComponent, null));
  }
}

SocialNetworkIcon.propTypes = {
  network: PropTypes.string.isRequired,
  size: PropTypes.string
};
SocialNetworkIcon.defaultProps = {
  size: 'medium',
  style: {},
  iconStyle: {}
};
export default SocialNetworkIcon;